module.exports = __webpack_public_path__ + "img/switch-2.361b85b3.webp";